import { storageApi } from "../storage/storageApi";
import { UserRoles } from "../storage/enums";

export const useRoleSelector = (selectOption, defaultValue) => {
  const { role } = storageApi.useGetUserRole();
  return selectOption[role] ?? defaultValue;
};

export const useRoleColor = () => {
  const { role } = storageApi.useGetUserRole();
  const mainColorList = {
    [UserRoles.Admin]: "#05505F",
    [UserRoles.Sazman]: "#05505F",
    [UserRoles.SazmanOstan]: "#05505F",
    [UserRoles.ModireKol]: "#05505F",
    [UserRoles.User]: "#0A4977",
  };

  const secondColorList = {
    [UserRoles.Admin]: "rgba(5,80,95,0.3)",
    [UserRoles.User]: "rgba(10,73,119,0.3)",
    [UserRoles.Sazman]: "rgba(5,80,95,0.3)",
    [UserRoles.SazmanOstan]: "rgba(5,80,95,0.3)",
    [UserRoles.ModireKol]: "rgba(5,80,95,0.3)",
  };
  const errorColorList = {
    [UserRoles.Admin]: "#9A0F0F",
    [UserRoles.User]: "#9A0F0F",
    [UserRoles.Sazman]: "#9A0F0F",
    [UserRoles.SazmanOstan]: "#9A0F0F",
    [UserRoles.ModireKol]: "#9A0F0F",
  };
  return {
    mainColor: mainColorList[role] ?? "#05505F",
    secondColor: secondColorList[role] ?? "rgba(5,80,95,0.7)",
    errorColor: errorColorList[role] ?? "#9A0F0F",
  };
};
